import gql from 'graphql-tag';

import { USER_ERROR_FIELDS } from 'core/errors';
import { Subscription } from 'core/subscription';
import { Mutation, Query } from 'core/index';

export const FILE_FIELDS = gql`
  fragment fileFields on File {
    id
    path
    url
    mimeType
    filename
    size
    completed
    cancelled
    permalink
    originalFile {
      id
    }
    conversionGltfjson {
      id
      status
      reason
      errorCode
      viewerSemver
      convertedFile {
        id
      }
    }
    creator {
      id
      username
    }
  }
`;

export const NEW_FILE_FIELDS = gql`
  fragment newFileFields on File {
    id
    path
    url
    filename
    completed
    cancelled
    permalink
    uploadUrl
    private
    isCopy
    size
  }
`;

export const FILE = gql`
  ${FILE_FIELDS}
  ${USER_ERROR_FIELDS}
  query File($id: ID) {
    file(id: $id) {
      result {
        ...fileFields
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;

export class FileQuery extends Query {
  static conf = {
    GQL: FILE,
    varNames: ['id'],
    resultPath: 'file.result',
    errorPath: 'file.userErrors',
  };
}

export const FILE_MUTATION = gql`
  ${NEW_FILE_FIELDS}
  ${USER_ERROR_FIELDS}
  mutation File($fileInput: FileInput) {
    file(fileData: $fileInput) {
      file {
        ...newFileFields
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;

export class FileMutation extends Mutation {
  static conf = {
    GQL: FILE_MUTATION,
    inputName: 'fileInput',
    resultPath: 'file.file',
    errorPath: 'file.userErrors',
  };
}

export const COMPLETE_FILE_MUTATION = gql`
  ${FILE_FIELDS}
  ${USER_ERROR_FIELDS}
  mutation CompleteFile($fileInput: FileInput) {
    file(fileData: $fileInput) {
      file {
        ...fileFields
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;

export class CompleteFileMutation extends Mutation {
  static conf = {
    GQL: COMPLETE_FILE_MUTATION,
    inputName: 'fileInput',
    resultPath: 'file.file',
    errorPath: 'file.userErrors',
  };
}

const CONVERSION_PROGRESS_FRAGMENT = gql`
  fragment conversionProgressStatus on FileProcess {
    fileId
    status
    reason
    errorCode
    progress
    steps
    type
    viewerSemver
  }
`;

const CONVERSION_PROGRESS_SUBSCRIPTION = gql`
  ${CONVERSION_PROGRESS_FRAGMENT}
  subscription ConversionProgressSubscription(
    $subscribeFileProcessInput: SubscribeFileProcessInput!
  ) {
    fileProcess(subscribeFileProcessInput: $subscribeFileProcessInput) {
      ...conversionProgressStatus
    }
  }
`;

export class ConversionProgressSubscription extends Subscription {
  static conf = {
    GQL: CONVERSION_PROGRESS_SUBSCRIPTION,
    resultPath: 'fileProcess',
  };
}

const CONVERSION_PROGRESS_POLLING = gql`
  ${USER_ERROR_FIELDS}
  query File($id: ID) {
    file(id: $id) {
      result {
        id
        conversionGltfjson {
          id
          status
          viewerSemver
          convertedFile {
            id
          }
        }
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;

export class FileConversionPolling extends Query {
  static conf = {
    GQL: CONVERSION_PROGRESS_POLLING,
    resultPath: 'file.result',
  };
}
